var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGooglePin = function SvgIconGooglePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.66663C6.3244 1.66663 3.33356 4.65746 3.33356 8.32913C3.3094 13.7 9.7469 18.1533 10.0002 18.3333C10.0002 18.3333 16.6911 13.7 16.6669 8.33329C16.6669 4.65746 13.6761 1.66663 10.0002 1.66663ZM10.0002 11.6666C8.15856 11.6666 6.6669 10.175 6.6669 8.33329C6.6669 6.49163 8.15856 4.99996 10.0002 4.99996C11.8419 4.99996 13.3336 6.49163 13.3336 8.33329C13.3336 10.175 11.8419 11.6666 10.0002 11.6666Z",
    fill: "#4EC6FF"
  })));
};
export default SvgIconGooglePin;